export default __webpack_public_path__ + "static/media/enterprise-eth.0f8302fe.webp";